<template>
  <div>
    <CCol sm="12">
        <CCard>
            <CCardBody class="d-flex flex-column">
                <CCol sm="12">
                    <!-- Name -->
                    <CRow>
                        <CCol sm="12">
                            <CInput label="Nome*" placeholder="" v-model="task.name" :is-valid="nameValidator"/>
                        </CCol>
                    </CRow>
                    <!-- Notes -->
                    <CRow>
                        <CCol sm="12">
                            <CTextarea label="Notas" placeholder="" vertical v-model="task.notes" :is-valid="genericValidator" rows="12"/>
                        </CCol>
                    </CRow>
                    <!-- Tools -->
                    <CRow>
                        <CCol sm="12">
                            <label class="">Ferramentas</label>
                        </CCol>
                    </CRow>
                    <CCol>
                        <CRow>
                            <div v-for="tool in tools" :key="tool.id" class="form-check col-3">
                                <input class="form-check-input" type="checkbox" :value="tool.id" :id="'tool-'+tool.id" v-model="task.tools">
                                <label class="form-check-label" :for="'tool-'+ tool.id">
                                    {{ tool.name }}
                                </label>
                            </div>
                        </CRow>
                    </CCol>
                    <!-- Action button -->
                    <CCol class="d-flex justify-content-end mt-3">
                        <CRow sm="2" class="align-self-end">
                            <CSpinner v-if="loading" variant="success" small></CSpinner>
                            <CButton v-else type="button" class="btn btn-primary" @click="submitClicked">Submeter</CButton>
                        </CRow>
                    </CCol>
                </CCol>
            </CCardBody>
        </CCard>
    </CCol>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Task from "@/classes/Task";
import InputTask from "@/classes/InputTask";
import InputGetTools from "@/classes/InputGetTools";
import { UTILS_HELPER } from "@/helpers/utils.js";

export default {
    props:{    
        baseTask:
        {
            type: Object,
            default: null
        }
    },
    data()
    {
        return {
            submitted: false,
            task: new Task(),
            loading: false
        }
    },
    mounted: function()
    {
        var input = new InputGetTools(1, 999);
        this.getList(input);
        
        this.resetTask();
    },
    computed:
    {
        ...mapState('alert', ['type']),
        ...mapState('alert', ['message']),
        ...mapState('tools', ['listOutput']),
        tools: function() {
            var result = [];
            if(this.listOutput && this.listOutput.obj)
            {
                result = this.listOutput.obj.tools;
            }

            return result;
        }
    },
    methods:{
        ...mapActions('tools', ['getList']),
        resetTask(){
            if(!this.baseTask)
            {
                this.task = new Task(null, null, []);
            }
            else
            {
                this.task = UTILS_HELPER.deepClone(new Task, this.baseTask);
                this.task.tools = this.task.tools.filter(function (tool) {
                    return tool.used;
                }).map(tool => tool.id);
            }
        },
        submitClicked(){
            this.submitted = true;

            // Emit event
            if(this.task.isValid())
            {
                var input = new InputTask(null, this.task);
                // TODO Replace by Task id
                if(this.baseTask && this.$route.params.id)
                {
                    input.id = this.$route.params.id;
                }

                this.loading = true;
                this.$emit('submit-requested', input);
            }
        },
        genericValidator(){
            var result = undefined; // This is the default, in case the user hasn't submitted yet

            // Validate error
            if(this.submitted && this.addError)
            {
                result = false;
            }

            return result;
        },
        nameValidator(){
            var result = this.genericValidator();

            if(this.submitted && result != false)
            {
                result = Boolean(this.task.name);
            }

            return result;
        }
    },
    watch:
    {
        baseTask: function(val)
        {
            this.resetTask();
        },
        type: function()
        {
            this.addError = this.type == "alert-danger" ? this.message : '';
            this.loading = false;
        },
        message: function()
        {
            this.addError = this.type == "alert-danger" ? this.message : '';
            this.loading = false;
        }
    }
}
</script>

<style>

</style>